"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.usePersonalSubscriptionAvailability = usePersonalSubscriptionAvailability;
var _checkoutUtils = require("@ori/checkout-utils");
var _environment = require("@ori/environment");
var _i18n = require("@ori/i18n");
var _staticApiClientReact = require("@ori/static-api-client-react");
var _contexts = require("../contexts");
var _logger = require("../logger");
function usePersonalSubscriptionAvailability(subscriptionItemCode, itemType) {
  const {
    tenant
  } = (0, _environment.useEnvironment)();
  const {
    isPersonalSubscriptionsEnabled
  } = (0, _contexts.useBasketContext)();
  const {
    language: lang
  } = (0, _i18n.useTranslationsWithNamespaces)();
  const {
    data: {
      subscription
    } = {},
    error: subscriptionQueryError,
    isValidating: isSubscriptionsReplacementsLoading
  } = (0, _staticApiClientReact.useGetTenantProduct)(tenant, subscriptionItemCode, {
    lang
  }, {
    swr: {
      enabled: isPersonalSubscriptionsEnabled && itemType === 'P',
      ..._checkoutUtils.errorHandlingSwrOptions,
      onSuccess: () => {
        (0, _logger.logDebug)('usePersonalSubscriptionAvailability() hook finished successfully');
      }
    }
  });
  return {
    subscriptionQueryError,
    isPersonalSubscriptionAvailable: subscription?.available ?? false,
    isSubscriptionsReplacementsLoading
  };
}